import { render, staticRenderFns } from "./ViewMyRequests.vue?vue&type=template&id=5ea7e79a&scoped=true&"
import script from "./ViewMyRequests.vue?vue&type=script&lang=js&"
export * from "./ViewMyRequests.vue?vue&type=script&lang=js&"
import style0 from "./ViewMyRequests.vue?vue&type=style&index=0&id=5ea7e79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea7e79a",
  null
  
)

export default component.exports